import { useEffect, useState } from 'react';

export const useFileReader = (file: Blob) => {
  const [fileUrl, setFileUrl] = useState<string | ArrayBuffer | null | undefined>(null);

  useEffect(() => {
    if (!file) return () => undefined;

    const reader = new FileReader();

    reader.onload = (e) => {
      setFileUrl(e.target?.result);
    };

    reader.readAsDataURL(file);

    return () => {
      reader.abort();
    };
  }, [file]);

  return fileUrl;
};
